import { ButtonGroup, MenuItem, Select, Typography } from '@mui/material'

import StyledPaper from '/components/paper'
import { periodOptions } from '/components/statistics/use-client-statistics'

const FilterBar = ({ periodDays, setPeriodDays, templateId, setTemplateId, selectableTemplates, summaryItems = [] }) => (
  <StyledPaper>
    <div className='flex flex-row flex-wrap items-center justify-between gap-4 p-5'>
      <div className='flex flex-row flex-wrap items-center gap-4'>
        <Select size='small' value={periodDays} onChange={e => setPeriodDays(Number(e.target.value))}>
          {periodOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
          ))}
        </Select>

        <Select
          size='small'
          value={templateId}
          onChange={e => setTemplateId(e.target.value)}
          displayEmpty
          renderValue={selected => {
            if (!selected) return 'All templates'
            return selectableTemplates.find(template => template.template_id === selected)?.name || selected
          }}
          sx={{ minWidth: 280 }}
        >
          <MenuItem value="">All templates</MenuItem>
          {selectableTemplates.map(template => (
            <MenuItem key={template.template_id} value={template.template_id}>{template.name}</MenuItem>
          ))}
        </Select>
      </div>

      {summaryItems.length > 0 &&
        <ButtonGroup>
          {summaryItems.map(item => (
            <SummaryItem key={item.title} title={item.title} value={item.value} />
          ))}
        </ButtonGroup>}
    </div>
  </StyledPaper>
)

export default FilterBar

export const SummaryItem = ({ title, value }) => (
  <div className='flex flex-col items-center px-5 py-2'>
    <Typography variant='caption'>{title}</Typography>
    <Typography variant='h6'>{Number(value || 0).toLocaleString()}</Typography>
  </div>
)
